import {
  mapGetters
} from 'vuex'

import SelectPageMenu from '../ccicropmenu/SelectPageMenu.vue';

export default {
  data () {
    return {
      checkedAndFoundPdf: this.PdfCheckEnum.UNCHECKED,
      articleFavTitle: '',
      leftRightArrayPrint: [],
      leftRightArrayCrop: [],
    }
  },
  beforeCreate () {
    this.PdfCheckEnum = {
      UNCHECKED: -1,
      CHECKED_NOT_FOUND: 0,
      CHECKED_AND_FOUND: 1
    }
  },
  mounted () {    
    this.setTabindexForButtonsInBurgerMenu()  
    this.layoutCropButton()
    this.layoutArticleDownloadButton()
    this.layoutButtonsArticleIsOnline()
  },
  computed: {
    isPagesShowing: function () {
      var pagesShowing = (this.$route.name === 'pages')

      this.$nextTick(function () {
        var sectionBarElem = document.getElementById('sections-bar')
        if (sectionBarElem !== null) {
          if (!pagesShowing) {
            sectionBarElem.style.display = 'none'
          } else if (this.sections.length > 1) {
            sectionBarElem.style.display = 'block'
          }
        }
      })
      return pagesShowing
    },
    title: function () {
      return this.$readerOptions.navigationBarTitle
    },
    isArticlesEmpty: function () {
      if (this.articles === undefined || this.articles.length < 1 || !this.$readerOptions.enableArticles) {
        return true
      }
      return false
    },
    isShowingSinglePage () {
      return this.currentPage !== undefined && !this.currentPage.secondPage
    },
    hasSinglePagePdf () {
      if (this.currentPage === undefined || this.currentPage.firstPage === undefined) {
        return false
      }
      let cur = this.currentPage
      return cur.firstPage &&
        cur.firstPage.pdf &&
        (!cur.secondPage || cur.secondPage.pdf) &&
        this.checkedAndFoundPdf === this.PdfCheckEnum.CHECKED_AND_FOUND
    },
    hasSportsXtraSection: function() {
      return (this.sections[this.sections.findIndex(x => x.name.toUpperCase() == 'SPORTSXTRA')]) !== undefined
    },
    displaySocialSharingButton: function () {
      if (this.$readerOptions.enableArticleSocialSharing &&
        this.currentArticle !== undefined &&
        (this.$route.name === 'article-mobile' || this.$route.name === 'articles') && 
        this.getShareURL(this.currentArticle) !== undefined) {
        if (this.$readerOptions.articleSharingType === 'online') {
          const onlineURL = this.getOnlineUrl(this.currentArticle)
          return onlineURL !== undefined && onlineURL !== ''
        }
        return true
      }
      return false
    },
    displayArticleFavIcon: function () {
      return this.shouldDisplayFavArticleIcon()
    },
    enableZoomButtons () {
      return this.isDesktop || this.$readerOptions.enableZoomButtonsForMobile
    },
    enablePagesModeSwitchButton () {
      return this.$readerOptions.enableSinglePagesModeSwitch && !this.isSinglePage && !this.isPhone && !this.isTabletPortrait
    },
    enableDisplayModeWidthButton () {
      return this.$readerOptions.enablePageViewModeChange && this.isFullPageViewMode
    },
    enableDisplayModeHeightButton () {
      return this.$readerOptions.enablePageViewModeChange && !this.isFullPageViewMode
    },
    enableFullScreenButton () {
      return this.$readerOptions.enableFullscreen && this.isDesktop
    },
    enableArticleAudioButton () {
      const isCurrentArticleOnline = this.lastArticleIsOnlineCheck !== undefined && this.lastArticleIsOnlineCheck.articleId === this.currentArticle.id ? this.lastArticleIsOnlineCheck.isValid : false
      return this.$store.state.hasTtsService && this.currentArticle !== undefined && this.currentArticle.html && !isCurrentArticleOnline && (this.$route.name === 'article-mobile' || this.$route.name === 'articles')
    },
    cropMenuButtonRef() {
      return this.$refs.cropMenuButton;
    },
    printMenuButtonRef() {
      return this.$refs.printMenuButton;
    },
    isSectionsBarEnabled() {
      return this.$readerOptions.enableSectionsBar && this.sections.length > 1 && this.$route.name === 'pages'
    },
    hasFunctionalButtons () {
      return this.$readerOptions.enableCropPage || this.$readerOptions.enablePrintOfPages || this.$readerOptions.enableDownloadOfPages || this.$readerOptions.enablePrintOfCurrentPage
    },
    hasViewChangeButtons () {
      return this.enableZoomButtons || this.enablePagesModeSwitchButton || this.enableDisplayModeWidthButton || this.enableDisplayModeHeightButton
    },
    hasNavigationButtons () {
      return this.$readerOptions.enableScrubber || this.$readerOptions.enableIssueOverview
    },
    ...mapGetters({
      currentArticle: 'getCurrentArticle',
      articles: 'getArticles',
      currentPage: 'getCurrentPage',
      pages: 'getPages',
      sections: 'getSections',
      isFullPageViewMode: 'getPageViewMode',
      favArticles: 'getFavArticles',
      showArticleModal: 'getShowArticleModal',
      showIssueOverview: 'getShowIssueOverview',
      showPrintMenu: 'getShowPrintMenu',
      showCropMenu: 'getShowCropMenu',
      isCurrentPageRendered: 'getIsCurrentPageRendered',
      showBurgerMenu: 'getShowBurgerMenu',
      articleViewMode: 'getArticleViewMode',
      isInSinglePagesMode: 'getIsInSinglePagesMode',
    })
  },
  watch: {
    // isMobileSize: function (newValue) {
    //   this.layoutNavigationBarSizes()
    // },
    currentPage: function (newValue) {
      if (this.checkedAndFoundPdf !== this.PdfCheckEnum.UNCHECKED) return
      if (!newValue && newValue.firstPage && newValue.firstPage.pdf) return

      let url = this.getEncodedResourceUrl(newValue.firstPage.pdf, newValue.firstPage.attributes.LastRev)

      // make HEAD request to check whether this issue has PDFs
      this.requestUrlTest(url).then((isValid) => {
        this.checkedAndFoundPdf = isValid ? this.PdfCheckEnum.CHECKED_AND_FOUND : this.PdfCheckEnum.CHECKED_NOT_FOUND
      })

      this.updateFavIcon()
    },
    currentArticle: function () {
      this.updateFavIcon()
      this.layoutButtonsArticleIsOnline()
    },
    '$route': function (to) {
      // if (to.name === 'article-mobile') {
      this.$nextTick(function() {
        this.setTabindexForButtonsInBurgerMenu()
      })
      if (to.name === 'article-mobile' || to.name === 'articles') {
        this.$nextTick(function() {
          this.updateFavIcon()
          this.layoutArticleDownloadButton()
          this.layoutButtonsArticleIsOnline()
        })
      } 
    },
    favArticles: {
      handler () {
        this.updateFavIcon()
      }, 
      deep: true      
    },
    isPortrait: function (newValue) {
      if (!newValue) {
        let burgerButton = document.getElementById('burger-button')
        let slider = document.getElementById('nav-right-pages')
        if (slider !== null && burgerButton !== null) {
          burgerButton.classList.remove('rotate-90-degree')
          slider.classList.remove('move-right')
        }
      }
    },
    isCurrentPageRendered () {
      this.setTabindexForButtonsInBurgerMenu()
      this.layoutCropButton()
    },
    showBurgerMenu: function (newValue) {
      const burgerButton = document.getElementById('burger-button')
      const display = window.getComputedStyle(burgerButton).getPropertyValue('display')
      if (display === 'none') {
        return
      }
      
      const slider = document.getElementById('nav-right-pages')  ? document.getElementById('nav-right-pages') : document.getElementById('nav-right-article-list')
      if (slider !== null && burgerButton !== null) {
        if (newValue) {
          burgerButton.classList.add('rotate-90-degree')
          slider.classList.add('move-right')
        } else {
          burgerButton.classList.remove('rotate-90-degree')
          slider.classList.remove('move-right')
        }
        const isExpanded = burgerButton.getAttribute('aria-expanded') === 'true'
        burgerButton.setAttribute('aria-expanded', !isExpanded)
        this.setTabindexForButtonsInBurgerMenu()
      }
    },
    articleViewMode () {
      this.layoutArticleDownloadButton()
      this.layoutButtonsArticleIsOnline()
    }
  },
  methods: {
    printArticle() {
      if (this.articlePrintIsDisabled) {
        return
      }
      this.$cciEventTrackingPlugin.trackEvent('ArticleView', 'ArticlePrintButtonClick', this.currentArticle)
      if (this.articleViewMode === 'image' || this.isTablesAsImages(this.currentArticle)) {
        // Determine the image format based on its background URL
        const imgFormat = this.getImageFormat(this.currentArticle.page.background);

        // Create the filename for the article image based on its ID and the determined format
        const articleImgFile = this.currentArticle.id + imgFormat;

        // Generate the URL for the image resource with the encoded filename and last revision attribute
        // Also, include the parameter to crop from the page if necessary
        const url = this.getEncodedResourceUrl(articleImgFile, this.currentArticle.attributes.LastRev) + '&cropFromPage=true';

        // Call the 'printImg' function, passing the generated URL to print the image
        this.printImg(url)
        return
      }
      try {
        let iframe = document.getElementById(this.currentArticle.id + '-article')
        if (iframe?.contentWindow) {
          iframe.contentWindow.print()
        }
      } catch (err) {
        console.log('Error printing article iframe:', err)
      }
    },
    // gotoSportsExtra() {
    //   this.$store.commit('setSportsExtraMenuSelected', true)
    // },
    toggleScrubber () {
      this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesScrubberButtonClick', this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
      this.$store.commit('toggleScrubberVisible')
    },
    openIssueOverview (printAndDownload, event) {
      if (!printAndDownload) {
        // issue overview button
        this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesIssueOverviewButtonClick')
      } else if (event.target.id === 'nav-download-icon') {
        // downlad button
        this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesIssueDownloadButtonClick')
      } else if (event.target.id === 'nav-print-icon') {
        // print button
        this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesIssuePrintButtonClick')
      }

      event.target.parentElement.blur()
      this.$store.commit('setShowIssueOverview', {val: true, printAndDownload: printAndDownload})
    },
    // handleGamesMenuClick () {
    //   if (this.$readerOptions.gamesUrl !== '') {
    //     window.open(this.$readerOptions.gamesUrl, '_blank')
    //   }
    // },
    // handleFAQMenuClick () {
    //   if (this.$readerOptions.helpUrl !== '') {
    //     window.location.href = this.$readerOptions.helpUrl
    //   }
    // },
    downloadIssue () {
      let confirmed = confirm("Are you sure, you want to download?")
      if (confirmed) {
        // remove /OPS/ from opsURL
        let url = this.$opsURL
        url = url.substr(0, url.lastIndexOf('/'))
        url = url.substr(0, url.lastIndexOf('/'))

        if (this.$store.state.hasGETFullIssue) {
          this.$http.get(url + '/pagespdffull?download=true', {responseType: 'blob'})
          .then((response) => {
            let filename = (response.headers.get('Content-Disposition') || '').split('filename=')[1]
            response.blob()
              .then((data) => {
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(data)
                link.download = filename
                document.body.appendChild(link)
                link.click()
              }, (response) => { console.log(response) })
          }, (response) => { console.log(response) })
        } else {
          let postData = []
          postData.push('fullIssue')
          // Make post request for issue and save response as download
          // Don't see any good way of doing this, so create an a tag with download attribute and click it
          this.$http.post(url + '/pagespdf', postData, {responseType: 'blob'})
            .then((response) => {
              let filename = (response.headers.get('Content-Disposition') || '').split('filename=')[1]
              response.blob()
                .then((data) => {
                  let link = document.createElement('a')
                  link.href = window.URL.createObjectURL(data)
                  link.download = filename
                  document.body.appendChild(link)
                  link.click()
                }, (response) => { console.log(response) })
            }, (response) => { console.log(response) })
        }
      }
    },
    leftRightPosition (e) {
      const el = e.currentTarget.children.item(0)
      const rect = el.getBoundingClientRect()
      return {
        x: rect.right,
        y: rect.bottom,
        direction: 'left'
      }
    },
    initiateCrop (pageSide) {
      if (pageSide === 0) {
        this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesCropButtonClick', this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
      } else if (pageSide === 1) {
        this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesCropButtonClick', this.currentPage.secondPage, this.currentPage.secondPage.attributes.Page)
      }

      let delay = 0
      if (pageSide !== this.$store.state.pageSide) {
        // selected different page - remove crop view from other page...
        this.$store.commit('setCropVisible', false)
        // the request to show the cropper for a different page must be delayed a bit.
        delay = 50
      }

      const that = this
      clearTimeout(this.cropVisibleTimeOut)
      this.cropVisibleTimeOut = setTimeout(function() {
        that.$store.commit('setCropPageSide', pageSide)
        that.$store.commit('setCropVisible', true)
        that.cropVisibleTimeOut = undefined
      }, delay)
    },
    openSinglePDFPage (pageSide) {
      const page = pageSide === 0 ? this.currentPage.firstPage : this.currentPage.secondPage
      let pdfUrl = page.pdf
      if (page.interstitialInfo !== null) {
        if (this.isPortrait) {
          pdfUrl = page.interstitialInfo.portraitPdf
        } else {
          pdfUrl = page.interstitialInfo.landscapePdf
        }
      }
      this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesPrintCurrentPageButtonClick', page, page.attributes.Page)
      window.open(this.getEncodedResourceUrl(pdfUrl, page.attributes.LastRev), '_blank')
    },
    openFullScreen () {
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement) {
        this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesFullscreenModeOffButtonClick', this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      } else {
        this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesFullscreenModeOnButtonClick', this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
        const elem = document.body
        if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen()
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen()
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen()
        }
      }
    },
    openSharing () {
      this.$cciEventTrackingPlugin.trackEvent('ArticleView', 'ArticleShareButtonClick', this.currentArticle, window.location.href)
      if (this.isDesktop || !navigator.canShare) {
        this.$store.commit('setShowSharing', true)
      } else {
        const url = this.getShareURL(this.currentArticle)
        const headTxt = this.currentArticle.attributes.TeaserText !== undefined ? this.currentArticle.attributes.TeaserText : this.currentArticle.attributes.Headline
        const shareData = {
          text: headTxt,
          url: url
        }
        const that = this
        navigator.share(shareData).then(
        function () {
          that.$cciEventTrackingPlugin.trackEvent('ArticleView', 'ArticleShareOpened', that.currentArticle, "native-sharing")
        }).catch(error => {
          console.log(error)
          that.$cciEventTrackingPlugin.trackEvent('ArticleView', 'ArticleShareCancelled', that.currentArticle, "native-sharing")
        })

        this.$store.commit('setShowBurgerMenu', false)
      }
    },
    routeToArticleList () {
      this.$cciEventTrackingPlugin.trackEvent('PageView', 'PagesArticleListButtonClick')
      if (typeof googletag !== 'undefined' && googletag.apiReady) {
        googletag.destroySlots()
      }

      if (!this.isPhone) {
        this.resetPagesLayout()
        this.routeTo('articles', { articleNr: '0' })
      } else {
        this.routeTo('articles-mobile')
      }
    },
    routeToPages () {
      if (this.isPhone) {
        document.getElementById('webreader-app').style.overflow = 'hidden'
      }
      this.$store.commit('hideAudioPlayer')
      let pageNr = '1';
      if (this.currentPage !== undefined) {
        pageNr = this.currentPage.firstPage.pageNumber;
      } else if (this.currentArticle !== undefined) {
        pageNr = this.currentArticle.page.pageNumber;
      }
      this.routeTo('pages', { pageNr: pageNr })
    },
    routeToHome () {
      if (this.$readerOptions.homeNavigationUrl !== '') {
        window.location.href = this.$readerOptions.homeNavigationUrl
      } else {
        window.location.href = document.referrer
      }
    },
    zoom (zoomIn) {
      const webreaderApp = document.getElementById('webreader-app')
      if (zoomIn) {
        var event1 = new CustomEvent('buttonZoomIn')
        webreaderApp.dispatchEvent(event1)
      } else {
        var event2 = new CustomEvent('buttonZoomOut')
        webreaderApp.dispatchEvent(event2)
      }

      // this.$store.commit('setZoomLevelButton', zoomIn)
    },
    incrementFontSize () {
      if (this.textSizeButtonsAreDisabled) {
        return
      }
      this.$store.commit('setFontSize', true)
    },
    decrementFontSize () {
      if (this.textSizeButtonsAreDisabled) {
        return
      }
      this.$store.commit('setFontSize', false)
    },
    toggleBurgerMenu () {
      this.$store.commit('setShowBurgerMenu', !this.showBurgerMenu)
    },
    // setNavIcon (iconClass, url) {
    //   if (url !== '') {
    //     var icon = document.getElementsByClassName(iconClass)[0]
    //     icon.style.background = 'url(' + url + ')'
    //     icon.style.backgroundSize = 'cover'
    //   }
    // },
    resetPagesLayout () {
      let pagesSwiperContainer = document.getElementById('pages-swiper-container')
      let sectionBar = document.getElementById('sections-bar')
      let nextButton = document.getElementById('page-nav-next-button')
      let prevButton = document.getElementById('page-nav-prev-button')

      pagesSwiperContainer.style.overflow = 'hidden'
      if (sectionBar !== null) {
        sectionBar.style.visibility = 'visible'
      }
      nextButton.style.display = 'inline-block'
      prevButton.style.display = 'inline-block'
    },
    setPageViewMode () {
      this.$store.commit('togglePageViewMode')
    },
    shouldDisplayFavArticleIcon () {
      return this.$readerOptions.enableArticleFavourite &&
        this.currentArticle !== undefined &&
        (this.$route.name === 'article-mobile' || this.$route.name === 'articles')
    },
    updateFavIcon () {
      const favElem = document.getElementById('nav-article-fav-icon')
      if (!this.shouldDisplayFavArticleIcon() || favElem === undefined) {
        return
      }
      if (this.isArticleFav()) {
        // favElem.classList.remove('nav-article-fav-add')
        favElem.classList.add('nav-article-fav-icon-dark')
        this.articleFavTitle = this.$t('cci_fav_article_remove_text')
      } else {
        favElem.classList.remove('nav-article-fav-icon-dark')
        // favElem.classList.add('nav-article-fav-add')
        this.articleFavTitle = this.$t('cci_fav_article_add_text')
      }
    },
    toggleFav () {
      if (!this.isArticleFav()) {
        this.$store.commit('addFavArticle', this.currentArticle.id)
        this.$cciEventTrackingPlugin.trackEvent('ArticleView', 'ArticleAddToFavouritesButtonClick', this.currentArticle, this.currentArticle.attributes.Headline)
      } else {
        this.$store.commit('removeFavArticle', this.currentArticle.id)
        this.$cciEventTrackingPlugin.trackEvent('ArticleView', 'ArticleRemoveFromFavouritesButtonClick', this.currentArticle, this.currentArticle.attributes.Headline)
      }
      this.updateFavIcon()
    },
    isArticleFav () {
      return this.currentArticle !== undefined ? this.favArticles.indexOf(this.currentArticle.id) > -1 : false
    },
    toggleAudioPlayer () {
      this.$store.commit('toggleShowAudioPlayer')
    },
    downloadImage () {
      if (this.downloadIsDisabled) {
        return
      }
      this.downloadImg(this.currentArticle)
    },
    toggleCropMenu() {
      if (this.cropIsDisabled) {
        return
      }
      this.$store.commit('setShowCropMenu', !this.showCropMenu)
    },
    togglePrintMenu() {
      this.$store.commit('setShowPrintMenu', !this.showPrintMenu)
    },
    handleCropAction(pageSide) {
      // Handle action one
      this.$store.commit('setShowCropMenu', false)
      this.initiateCrop(pageSide);
    },
    handlePrintAction(pageSide) {
      // Handle action one
      this.$store.commit('setShowPrintMenu', false)
      this.openSinglePDFPage(pageSide);
    },
    menuOutOfFocus () {
      if (this.showPrintMenu) {
        this.$store.commit('setShowPrintMenu', false)
      } else if (this.showCropMenu) {
        this.$store.commit('setShowCropMenu', false)
      }
    },
    closeMenu () {
      if (this.showPrintMenu) {
        this.$store.commit('setShowPrintMenu', false)
        // focus on print menu button
        this.printMenuButtonRef.focus()
      } else if (this.showCropMenu) {
        this.$store.commit('setShowCropMenu', false)
        // focus on crop menu button
        this.cropMenuButtonRef.focus()
      }
    },
    toggleSinglePagesMode () {
      if (!this.$readerOptions.enableSinglePagesModeSwitch) {
        return
      }
      this.$store.commit('setIsInSinglePagesMode', !this.isInSinglePagesMode)
      const eventAction = this.isInSinglePagesMode ? 'PagesSinglePagesModeButtonClick' : 'PagesDoublePagesModeButtonClick'
      this.$cciEventTrackingPlugin.trackEvent('PagesView', eventAction, this.currentPage.firstPage, this.currentPage.firstPage.attributes.Page)
    },
    skipToSectionsBar () {
      // Skip the navigation bar - focus on sections bar
      const sectionsBar = document.getElementById('sections-bar')
      if (sectionsBar !== null) {
        sectionsBar.setAttribute('tabindex', -1)
        sectionsBar.focus()
      }
      

        // Skip the navigation bar - focus on skip section bar link

        // const skipSectionBar = document.getElementById('skip-section-bar')
        // if (skipSectionBar !== null) {
        //   skipSectionBar.focus()
        // } else {
        //   // If no sections bar, focus on first interactive layer on the page
        //   const interactiveLayers = document.getElementsByClassName('layer')
        //   if (interactiveLayers.length > 0) {
        //     interactiveLayers[0].focus()
        //   } else {
        //     // If no interactive layers, focus on next page button
        //     const nextPageButton = document.getElementById('next-page-button')
        //     if (nextPageButton !== null) {
        //       nextPageButton.focus()
        //     }
        //   }
        // }
      // }

      // if (this.$route.name === 'articles') {
      //   // skip to skip article list link
      //   const skipArticleList = document.getElementById('skip-article-list')
      //   if (skipArticleList !== null) {
      //     skipArticleList.focus()
      //   }
      // }
    },
    setTabindexForButtonsInBurgerMenu () {
      const burgerMenuButton = document.getElementById('burger-button')
      if (burgerMenuButton !== null && getComputedStyle(burgerMenuButton).display !== 'none') {
        // set tabindex for all buttons in burger menu
        const buttons = document.getElementsByClassName('nav-button-right')
        for (const button of buttons) {
          button.setAttribute('tabindex', this.showBurgerMenu ? 0 : -1)
          this.showBurgerMenu ? button.removeAttribute('aria-hidden') : button.setAttribute('aria-hidden', 'true')
          this.showBurgerMenu ? button.removeAttribute('aria-disabled') : button.setAttribute('aria-disabled', 'true')
        }
      }
    },
    layoutButtonsArticleIsOnline () {
      if (this.currentArticle === undefined) {
        return
      }

      if (this.lastArticleIsOnlineCheck !== undefined &&
          this.lastArticleIsOnlineCheck.articleId === this.currentArticle.id) {
        // use cached value
        this.layoutArticlePrintButton(this.lastArticleIsOnlineCheck.isValid)
        this.layoutTextSizeButtons(this.lastArticleIsOnlineCheck.isValid)
        return
      }

      const onlineURL = this.getOnlineUrl(this.currentArticle)
      if (this.$readerOptions.enableOnlineURLArticles && onlineURL !== undefined && onlineURL !== '') {
        this.requestUrlTest(onlineURL, false, 'no-cors').then((isValid) => {
          this.layoutArticlePrintButton(isValid)
          this.layoutTextSizeButtons(isValid)
          this.lastArticleIsOnlineCheck = {articleId: this.currentArticle.id, isValid: isValid}
        })
      } else {
        this.layoutArticlePrintButton()
        this.layoutTextSizeButtons()
      }
    },
    layoutCropButton () {
      const cropIcons = document.getElementsByClassName('nav-crop-button')
      for (let i = 0; i < cropIcons.length; i++) {
        const cropIconElem = cropIcons[i]
        if (this.isCurrentPageRendered) {
          cropIconElem.classList.remove('nav-button-disable')
          cropIconElem.setAttribute('aria-disabled', 'false')
          cropIconElem.setAttribute('tabindex', '0')
          this.cropIsDisabled = false
        } else {
          cropIconElem.classList.add('nav-button-disable')
          cropIconElem.setAttribute('aria-disabled', 'true')
          cropIconElem.setAttribute('tabindex', '-1')
          this.cropIsDisabled = true
        }
      }
    },
    layoutTextSizeButtons (isOnlineArticle = false) {
      const textIcons = document.getElementsByClassName('nav-text-size-button')      
      for (let i = 0; i < textIcons.length; i++) {
        const textIconElem = textIcons[i]
        if (this.articleViewMode === 'text' && !isOnlineArticle && !this.isTablesAsImages(this.currentArticle)) {
          textIconElem.classList.remove('nav-button-disable')
          textIconElem.setAttribute('aria-disabled', 'false')
          textIconElem.setAttribute('tabindex', '0')
          this.textSizeButtonsAreDisabled = false
        } else {
          textIconElem.classList.add('nav-button-disable')
          textIconElem.setAttribute('aria-disabled', 'true')
          textIconElem.setAttribute('tabindex', '-1')
          this.textSizeButtonsAreDisabled = true
        }
      }
    },
    layoutArticleDownloadButton () {
      const downloadIcon = document.getElementById('nav-article-download-button')
      if (downloadIcon !== null) {
        if (this.articleViewMode === 'text' && !this.isTablesAsImages(this.currentArticle)) {
          downloadIcon.classList.add('nav-button-disable')
          downloadIcon.setAttribute('aria-disabled', 'true')
          downloadIcon.setAttribute('tabindex', '-1')
          this.downloadIsDisabled = true
        } else {
          downloadIcon.classList.remove('nav-button-disable')
          downloadIcon.setAttribute('aria-disabled', 'false')
          downloadIcon.setAttribute('tabindex', '0')
          this.downloadIsDisabled = false
        }
      }
    },
    layoutArticlePrintButton (isOnlineArticle = false) {
      const printIcon = document.getElementById('nav-article-print-button')
      if (printIcon !== null) {
        if (this.articleViewMode === 'text' && isOnlineArticle) {
          printIcon.classList.add('nav-button-disable')
          printIcon.setAttribute('aria-disabled', 'true')
          printIcon.setAttribute('tabindex', '-1')
          this.articlePrintIsDisabled = true
        } else {
          printIcon.classList.remove('nav-button-disable')
          printIcon.setAttribute('aria-disabled', 'false')
          printIcon.setAttribute('tabindex', '0')
          this.articlePrintIsDisabled = false
        }
      }
    }
  },
  components: {
    SelectPageMenu
  }
}
